import type { ReactNode } from 'react';
import { Suspense } from 'react';

import ActiveLottieLinkClient from './ActiveLottieLinkClient';

type MappingPath = 'live' | 'ranking' | 'pick' | 'vModePick' | 'vModeRanking' | 'vModeLive';

interface Props {
  children: ReactNode;
  mappingPath: MappingPath;
  disabled?: boolean;
}

export default function ActiveLottieLink(props: Props) {
  return (
    <Suspense
      fallback={
        <div className='flex h-[50px] w-full items-center rounded-[10px] px-[17px] py-[11px] text-[15px]'>
          <div className='mr-[25px] h-[22px] w-[22px]' />
          <div className='h-[15px] w-[40px] rounded' />
        </div>
      }
    >
      <ActiveLottieLinkClient {...props} />
    </Suspense>
  );
}
